import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUi from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import qs from "qs";
import echarts from "echarts";

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;

// 菜单缩放报错解决---fragment
import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin);

// axios.defaults.baseURL = '/'  //api即vue.config.js中配置的地址
// axios.defaults.baseURL = "http://127.0.0.1:5010"; //服务器地址
axios.defaults.baseURL = "http://e.110c.net"; //服务器地址
// axios.defaults.baseURL = "http://121.40.121.90:5010"; //服务器地址
// axios.defaults.timeout =  20000;
Vue.config.productionTip = false;

Vue.use(ElementUi, {
  size: "mini"
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
